// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"929d8de2","455":"a3f0725c","977":"8acc270d"}[chunkId] + ".chunk.js";
};